
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestteethaligners/privacy-policy",
      function () {
        return require("private-next-pages/bestteethaligners/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestteethaligners/privacy-policy"])
      });
    }
  